// Verbal Analogies Questions for AFOQT
// 200 questions testing relationship recognition between word pairs
// Mix of two formats with AFOQT-level difficulty

export const verbalAnalogiesData = [
  // Questions 1-50: Mixed difficulty and formats
  {
    id: 1,
    text: "MENDACIOUS is to TRUTHFUL as BELLICOSE is to",
    options: ["PEACEFUL", "WARLIKE", "AGGRESSIVE", "HOSTILE", "COMBATIVE"],
    correct: 0,
    explanation: "MENDACIOUS (lying) is opposite to TRUTHFUL; BELLICOSE (warlike) is opposite to PEACEFUL."
  },
  {
    id: 2,
    text: "NOVEL : FICTION :: ATLAS : ?",
    options: ["GEOGRAPHY", "MAPS", "REFERENCE", "TITAN", "TRAVEL"],
    correct: 2,
    explanation: "A NOVEL is a type of FICTION; an ATLAS is a type of REFERENCE material."
  },
  {
    id: 3,
    text: "EPHEMERAL is to PERMANENT as TURBULENT is to",
    options: ["STORMY", "VIOLENT", "CALM", "ROUGH", "CHAOTIC"],
    correct: 2,
    explanation: "EPHEMERAL (temporary) is opposite to PERMANENT; TURBULENT is opposite to CALM."
  },
  {
    id: 4,
    text: "SCALPEL : SURGEON :: GAVEL : ?",
    options: ["COURT", "JUDGE", "LAW", "VERDICT", "TRIAL"],
    correct: 1,
    explanation: "A SCALPEL is the tool of a SURGEON; a GAVEL is the tool of a JUDGE."
  },
  {
    id: 5,
    text: "LACONIC is to VERBOSE as FRUGAL is to",
    options: ["CHEAP", "THRIFTY", "EXTRAVAGANT", "CAREFUL", "ECONOMICAL"],
    correct: 2,
    explanation: "LACONIC (brief) is opposite to VERBOSE; FRUGAL is opposite to EXTRAVAGANT."
  },
  {
    id: 6,
    text: "CRESCENDO : MUSIC :: CLIMAX : ?",
    options: ["STORY", "DRAMA", "CONFLICT", "RESOLUTION", "ENDING"],
    correct: 0,
    explanation: "A CRESCENDO is the peak moment in MUSIC; a CLIMAX is the peak moment in a STORY."
  },
  {
    id: 7,
    text: "INNOCUOUS is to HARMFUL as LUCID is to",
    options: ["CLEAR", "BRIGHT", "OBSCURE", "TRANSPARENT", "BRILLIANT"],
    correct: 2,
    explanation: "INNOCUOUS (harmless) is opposite to HARMFUL; LUCID (clear) is opposite to OBSCURE."
  },
  {
    id: 8,
    text: "CATALYST : REACTION :: SPARK : ?",
    options: ["EXPLOSION", "IGNITION", "ICE", "HEAT", "COMBUSTION"],
    correct: 1,
    explanation: "A CATALYST initiates a REACTION; a SPARK initiates IGNITION."
  },
  {
    id: 9,
    text: "ABSTEMIOUS is to INDULGENT as DIFFIDENT is to",
    options: ["SHY", "TIMID", "CONFIDENT", "HUMBLE", "RESERVED"],
    correct: 2,
    explanation: "ABSTEMIOUS (restrained) is opposite to INDULGENT; DIFFIDENT (shy) is opposite to CONFIDENT."
  },
  {
    id: 10,
    text: "ARCHIPELAGO : ISLANDS :: CONSTELLATION : ?",
    options: ["SKY", "STARS", "SPACE", "GALAXY", "ASTRONOMY"],
    correct: 1,
    explanation: "An ARCHIPELAGO is a group of ISLANDS; a CONSTELLATION is a group of STARS."
  },
  {
    id: 11,
    text: "PERFIDIOUS is to LOYAL as CAPRICIOUS is to",
    options: ["WHIMSICAL", "FICKLE", "STEADY", "IMPULSIVE", "CHANGEABLE"],
    correct: 2,
    explanation: "PERFIDIOUS (treacherous) is opposite to LOYAL; CAPRICIOUS (unpredictable) is opposite to STEADY."
  },
  {
    id: 12,
    text: "METRONOME : TEMPO :: COMPASS : ?",
    options: ["NORTH", "DIRECTION", "NAVIGATION", "MAP", "TRAVEL"],
    correct: 1,
    explanation: "A METRONOME indicates TEMPO; a COMPASS indicates DIRECTION."
  },
  {
    id: 13,
    text: "ASSIDUOUS is to NEGLIGENT as MALLEABLE is to",
    options: ["FLEXIBLE", "SOFT", "RIGID", "BENDABLE", "PLIABLE"],
    correct: 2,
    explanation: "ASSIDUOUS (diligent) is opposite to NEGLIGENT; MALLEABLE (flexible) is opposite to RIGID."
  },
  {
    id: 14,
    text: "PRISM : LIGHT :: CATALYST : ?",
    options: ["CHEMISTRY", "REACTION", "SPEED", "CHANGE", "SUBSTANCE"],
    correct: 1,
    explanation: "A PRISM disperses LIGHT; a CATALYST accelerates a REACTION."
  },
  {
    id: 15,
    text: "SAGACIOUS is to FOOLISH as COPIOUS is to",
    options: ["ABUNDANT", "PLENTIFUL", "SCARCE", "NUMEROUS", "AMPLE"],
    correct: 2,
    explanation: "SAGACIOUS (wise) is opposite to FOOLISH; COPIOUS (abundant) is opposite to SCARCE."
  },
  {
    id: 16,
    text: "CHRYSALIS : BUTTERFLY :: TADPOLE : ?",
    options: ["POND", "FROG", "WATER", "AMPHIBIAN", "METAMORPHOSIS"],
    correct: 1,
    explanation: "A CHRYSALIS develops into a BUTTERFLY; a TADPOLE develops into a FROG."
  },
  {
    id: 17,
    text: "GARRULOUS is to TACITURN as OBSTINATE is to",
    options: ["STUBBORN", "YIELDING", "FIRM", "DETERMINED", "RESOLUTE"],
    correct: 1,
    explanation: "GARRULOUS (talkative) is opposite to TACITURN; OBSTINATE (stubborn) is opposite to YIELDING."
  },
  {
    id: 18,
    text: "SONNET : POEM :: HAIKU : ?",
    options: ["JAPANESE", "POETRY", "SHORT", "VERSE", "LITERATURE"],
    correct: 1,
    explanation: "A SONNET is a type of POEM; a HAIKU is a type of POETRY."
  },
  {
    id: 19,
    text: "INCENDIARY is to EXTINGUISHING as NOURISHING is to",
    options: ["FEEDING", "HEALTHY", "STARVING", "EATING", "NUTRITIOUS"],
    correct: 2,
    explanation: "INCENDIARY (fire-starting) is opposite to EXTINGUISHING; NOURISHING is opposite to STARVING."
  },
  {
    id: 20,
    text: "DECIBEL : SOUND :: KELVIN : ?",
    options: ["COLD", "TEMPERATURE", "HEAT", "SCIENCE", "MEASUREMENT"],
    correct: 1,
    explanation: "DECIBEL measures SOUND intensity; KELVIN measures TEMPERATURE."
  },
  {
    id: 21,
    text: "AMELIORATE is to WORSEN as MITIGATE is to",
    options: ["LESSEN", "REDUCE", "AGGRAVATE", "EASE", "SOFTEN"],
    correct: 2,
    explanation: "AMELIORATE (improve) is opposite to WORSEN; MITIGATE (reduce) is opposite to AGGRAVATE."
  },
  {
    id: 22,
    text: "AXIOM : MATHEMATICS :: TENET : ?",
    options: ["BELIEF", "ORGANIZATION", "PRINCIPLE", "TRUTH", "FAITH"],
    correct: 1,
    explanation: "An AXIOM is a fundamental principle in MATHEMATICS; a TENET is a fundamental principle in an ORGANIZATION."
  },
  {
    id: 23,
    text: "PARSIMONIOUS is to GENEROUS as PRAGMATIC is to",
    options: ["PRACTICAL", "REALISTIC", "IDEALISTIC", "SENSIBLE", "RATIONAL"],
    correct: 2,
    explanation: "PARSIMONIOUS (stingy) is opposite to GENEROUS; PRAGMATIC (practical) is opposite to IDEALISTIC."
  },
  {
    id: 24,
    text: "QUARANTINE : DISEASE :: EMBARGO : ?",
    options: ["TRADE", "COUNTRY", "GOODS", "COMMERCE", "BAN"],
    correct: 0,
    explanation: "QUARANTINE restricts DISEASE spread; EMBARGO restricts TRADE."
  },
  {
    id: 25,
    text: "ACRID is to SWEET as TURBID is to",
    options: ["MUDDY", "CLOUDY", "CLEAR", "DIRTY", "MURKY"],
    correct: 2,
    explanation: "ACRID (bitter) is opposite to SWEET; TURBID (cloudy) is opposite to CLEAR."
  },
  {
    id: 26,
    text: "FILIBUSTER : LEGISLATION :: VETO : ?",
    options: ["PRESIDENT", "BILL", "CONGRESS", "LAW", "VOTE"],
    correct: 1,
    explanation: "A FILIBUSTER delays LEGISLATION; a VETO blocks a BILL."
  },
  {
    id: 27,
    text: "CONVIVIAL is to HOSTILE as METICULOUS is to",
    options: ["CAREFUL", "PRECISE", "CARELESS", "DETAILED", "THOROUGH"],
    correct: 2,
    explanation: "CONVIVIAL (friendly) is opposite to HOSTILE; METICULOUS (careful) is opposite to CARELESS."
  },
  {
    id: 28,
    text: "ALTIMETER : ALTITUDE :: ANEMOMETER : ?",
    options: ["PRESSURE", "WIND", "WEATHER", "SPEED", "DIRECTION"],
    correct: 1,
    explanation: "An ALTIMETER measures ALTITUDE; an ANEMOMETER measures WIND speed."
  },
  {
    id: 29,
    text: "PRECOCIOUS is to DELAYED as AFFLUENT is to",
    options: ["WEALTHY", "RICH", "IMPOVERISHED", "PROSPEROUS", "ABUNDANT"],
    correct: 2,
    explanation: "PRECOCIOUS (early) is opposite to DELAYED; AFFLUENT (wealthy) is opposite to IMPOVERISHED."
  },
  {
    id: 30,
    text: "PROLOGUE : NOVEL :: OVERTURE : ?",
    options: ["MUSIC", "OPERA", "ORCHESTRA", "SYMPHONY", "PERFORMANCE"],
    correct: 1,
    explanation: "A PROLOGUE introduces a NOVEL; an OVERTURE introduces an OPERA."
  },
  {
    id: 31,
    text: "LAUDATORY is to CRITICAL as BENIGN is to",
    options: ["KIND", "GENTLE", "MALIGNANT", "HARMLESS", "MILD"],
    correct: 2,
    explanation: "LAUDATORY (praising) is opposite to CRITICAL; BENIGN (harmless) is opposite to MALIGNANT."
  },
  {
    id: 32,
    text: "PLAGIARISM : WRITING :: FORGERY : ?",
    options: ["CRIME", "ART", "MONEY", "DOCUMENT", "IDENTITY"],
    correct: 3,
    explanation: "PLAGIARISM is fraudulent WRITING; FORGERY is a fraudulent DOCUMENT."
  },
  {
    id: 33,
    text: "TRANSIENT is to PERMANENT as SUPERFICIAL is to",
    options: ["SHALLOW", "SURFACE", "PROFOUND", "SKIN-DEEP", "CURSORY"],
    correct: 2,
    explanation: "TRANSIENT (temporary) is opposite to PERMANENT; SUPERFICIAL is opposite to PROFOUND."
  },
  {
    id: 34,
    text: "SYLLABUS : COURSE :: AGENDA : ?",
    options: ["MEETING", "PLAN", "SCHEDULE", "BUSINESS", "ITEMS"],
    correct: 0,
    explanation: "A SYLLABUS outlines a COURSE; an AGENDA outlines a MEETING."
  },
  {
    id: 35,
    text: "AUSTERE is to LAVISH as CRYPTIC is to",
    options: ["MYSTERIOUS", "HIDDEN", "OBVIOUS", "SECRET", "OBSCURE"],
    correct: 2,
    explanation: "AUSTERE (simple) is opposite to LAVISH; CRYPTIC (mysterious) is opposite to OBVIOUS."
  },
  {
    id: 36,
    text: "STETHOSCOPE : HEARTBEAT :: SEISMOGRAPH : ?",
    options: ["EARTH", "EARTHQUAKE", "TREMOR", "GROUND", "MOVEMENT"],
    correct: 1,
    explanation: "A STETHOSCOPE detects HEARTBEAT; a SEISMOGRAPH detects EARTHQUAKE activity."
  },
  {
    id: 37,
    text: "REDUNDANT is to NECESSARY as PUNGENT is to",
    options: ["SHARP", "STRONG", "MILD", "ACRID", "BITTER"],
    correct: 2,
    explanation: "REDUNDANT (unnecessary) is opposite to NECESSARY; PUNGENT (strong-smelling) is opposite to MILD."
  },
  {
    id: 38,
    text: "PREAMBLE : CONSTITUTION :: PREFACE : ?",
    options: ["INTRODUCTION", "BOOK", "AUTHOR", "CHAPTER", "BEGINNING"],
    correct: 1,
    explanation: "A PREAMBLE introduces a CONSTITUTION; a PREFACE introduces a BOOK."
  },
  {
    id: 39,
    text: "ERUDITE is to IGNORANT as CORPULENT is to",
    options: ["FAT", "OBESE", "GAUNT", "HEAVY", "LARGE"],
    correct: 2,
    explanation: "ERUDITE (learned) is opposite to IGNORANT; CORPULENT (obese) is opposite to GAUNT."
  },
  {
    id: 40,
    text: "QUARRY : STONE :: APIARY : ?",
    options: ["HONEY", "BEES", "HIVE", "WAX", "INSECTS"],
    correct: 1,
    explanation: "A QUARRY produces STONE; an APIARY produces BEES (houses bees)."
  },
  {
    id: 41,
    text: "SANGUINE is to PESSIMISTIC as ZEALOUS is to",
    options: ["ENTHUSIASTIC", "PASSIONATE", "APATHETIC", "EAGER", "FERVENT"],
    correct: 2,
    explanation: "SANGUINE (optimistic) is opposite to PESSIMISTIC; ZEALOUS (enthusiastic) is opposite to APATHETIC."
  },
  {
    id: 42,
    text: "THESIS : DISSERTATION :: HYPOTHESIS : ?",
    options: ["THEORIZE", "EXPERIMENT", "SCIENCE", "RESEARCH", "CONCLUSION"],
    correct: 1,
    explanation: "A THESIS is the central argument of a DISSERTATION; a HYPOTHESIS is the central idea tested in an EXPERIMENT."
  },
  {
    id: 43,
    text: "VENERABLE is to DISRESPECTED as PRISTINE is to",
    options: ["CLEAN", "PURE", "TARNISHED", "SPOTLESS", "IMMACULATE"],
    correct: 2,
    explanation: "VENERABLE (respected) is opposite to DISRESPECTED; PRISTINE (pure) is opposite to TARNISHED."
  },
  {
    id: 44,
    text: "CONDUCTOR : ORCHESTRA :: CHOREOGRAPHER : ?",
    options: ["OPERA", "CONCERT", "DANCERS", "STAGE", "PERFORMANCE"],
    correct: 2,
    explanation: "A CONDUCTOR directs an ORCHESTRA; a CHOREOGRAPHER directs DANCERS."
  },
  {
    id: 45,
    text: "TENACIOUS is to YIELDING as AUDACIOUS is to",
    options: ["BOLD", "DARING", "TIMID", "BRAVE", "FEARLESS"],
    correct: 2,
    explanation: "TENACIOUS (persistent) is opposite to YIELDING; AUDACIOUS (bold) is opposite to TIMID."
  },
  {
    id: 46,
    text: "OCTAGON : EIGHT :: PENTAGON : ?",
    options: ["FIVE", "SHAPE", "SIDES", "GEOMETRY", "POLYGON"],
    correct: 0,
    explanation: "An OCTAGON has EIGHT sides; a PENTAGON has FIVE sides."
  },
  {
    id: 47,
    text: "OBSOLETE is to CURRENT as DORMANT is to",
    options: ["SLEEPING", "INACTIVE", "ACTIVE", "RESTING", "LATENT"],
    correct: 2,
    explanation: "OBSOLETE (outdated) is opposite to CURRENT; DORMANT (inactive) is opposite to ACTIVE."
  },
  {
    id: 48,
    text: "GLACIER : ICE :: VOLCANO : ?",
    options: ["MOUNTAIN", "FLOE", "FIRE", "ERUPTION", "MAGMA"],
    correct: 4,
    explanation: "A GLACIER is made of ICE; a VOLCANO contains MAGMA."
  },
  {
    id: 49,
    text: "PLACID is to AGITATED as OPULENT is to",
    options: ["RICH", "LUXURIOUS", "AUSTERE", "WEALTHY", "LAVISH"],
    correct: 2,
    explanation: "PLACID (calm) is opposite to AGITATED; OPULENT (luxurious) is opposite to AUSTERE."
  },
  {
    id: 50,
    text: "ALLEGORY : SYMBOLISM :: PARODY : ?",
    options: ["COMEDY", "SATIRE", "HUMOR", "MOCKERY", "IMITATION"],
    correct: 1,
    explanation: "An ALLEGORY uses SYMBOLISM; a PARODY uses SATIRE."
  },

  // Questions 51-100
{
    id: 51,
    text: "CIRCUMSPECT is to RECKLESS as TACIT is to",
    options: ["SILENT", "EXPLICIT", "UNSPOKEN", "IMPLIED", "UNDERSTOOD"],
    correct: 1,
    explanation: "CIRCUMSPECT (cautious) is opposite to RECKLESS; TACIT (implied) is opposite to EXPLICIT."
  },
  {
    id: 52,
    text: "BAROMETER : PRESSURE :: HYGROMETER : ?",
    options: ["TEMPERATURE", "HUMIDITY", "WEATHER", "MOISTURE", "RAIN"],
    correct: 1,
    explanation: "A BAROMETER measures atmospheric PRESSURE; a HYGROMETER measures HUMIDITY."
  },
  {
    id: 53,
    text: "FASTIDIOUS is to SLOPPY as GREGARIOUS is to",
    options: ["SOCIABLE", "FRIENDLY", "OUTGOING", "SOCIAL", "RECLUSIVE"],
    correct: 4,
    explanation: "FASTIDIOUS (meticulous) is opposite to SLOPPY; GREGARIOUS (social) is opposite to RECLUSIVE."
  },
  {
    id: 54,
    text: "ELEGY : SORROW :: EULOGY : ?",
    options: ["PRAISE", "DEATH", "FUNERAL", "SPEECH", "MEMORIAL"],
    correct: 0,
    explanation: "An ELEGY expresses SORROW; a EULOGY expresses PRAISE for the deceased."
  },
  {
    id: 55,
    text: "INNOCUOUS is to NOXIOUS as BENEVOLENT is to",
    options: ["KIND", "CHARITABLE", "GENEROUS", "MALEVOLENT", "GOOD"],
    correct: 3,
    explanation: "INNOCUOUS (harmless) is opposite to NOXIOUS; BENEVOLENT (kind) is opposite to MALEVOLENT."
  },
  {
    id: 56,
    text: "DYNASTY : RULERS :: ANTHOLOGY : ?",
    options: ["BOOKS", "STORIES", "WRITINGS", "AUTHORS", "POEMS"],
    correct: 2,
    explanation: "A DYNASTY is a succession of RULERS; an ANTHOLOGY is a collection of WRITINGS."
  },
  {
    id: 57,
    text: "ARDUOUS is to EFFORTLESS as UBIQUITOUS is to",
    options: ["EVERYWHERE", "RARE", "COMMON", "FREQUENT", "ABUNDANT"],
    correct: 1,
    explanation: "ARDUOUS (difficult) is opposite to EFFORTLESS; UBIQUITOUS (everywhere) is opposite to RARE."
  },
  {
    id: 58,
    text: "QUILL : WRITE :: AWL : ?",
    options: ["SEW", "TOOL", "PIERCE", "LEATHER", "TAN"],
    correct: 2,
    explanation: "A QUILL is used to WRITE; an AWL is used to PIERCE holes."
  },
  {
    id: 59,
    text: "STOIC is to EMOTIONAL as CANDID is to",
    options: ["HONEST", "FRANK", "OPEN", "DECEPTIVE", "SINCERE"],
    correct: 3,
    explanation: "STOIC (unemotional) is opposite to EMOTIONAL; CANDID (honest) is opposite to DECEPTIVE."
  },
  {
    id: 60,
    text: "TUNDRA : ARCTIC :: SAVANNA : ?",
    options: ["GRASSLANDS", "DESSERT", "TROPICAL", "DESERT", "PLAINS"],
    correct: 0,
    explanation: "TUNDRA is characteristic of the ARCTIC; SAVANNA is characteristic of GRASSLANDS."
  },
  {
    id: 61,
    text: "NEBULOUS is to CLEAR as SUCCINCT is to",
    options: ["BRIEF", "CONCISE", "SHORT", "WORDY", "TERSE"],
    correct: 3,
    explanation: "NEBULOUS (vague) is opposite to CLEAR; SUCCINCT (brief) is opposite to WORDY."
  },
  {
    id: 62,
    text: "CARTOGRAPHER : MAPS :: LEXICOGRAPHER : ?",
    options: ["WORDS", "DICTIONARIES", "LANGUAGE", "BOOKS", "DEFINITIONS"],
    correct: 1,
    explanation: "A CARTOGRAPHER creates MAPS; a LEXICOGRAPHER creates DICTIONARIES."
  },
  {
    id: 63,
    text: "PRODIGAL is to THRIFTY as FERVENT is to",
    options: ["PASSIONATE", "INDIFFERENT", "ENTHUSIASTIC", "ZEALOUS", "EAGER"],
    correct: 1,
    explanation: "PRODIGAL (wasteful) is opposite to THRIFTY; FERVENT (passionate) is opposite to INDIFFERENT."
  },
  {
    id: 64,
    text: "SONATA : PIANO :: CONCERTO : ?",
    options: ["MUSIC", "ORCHESTRA", "SYMPHONY", "SOLO", "PERFORMANCE"],
    correct: 1,
    explanation: "A SONATA is composed for PIANO; a CONCERTO is composed for soloist and ORCHESTRA."
  },
  {
    id: 65,
    text: "INTREPID is to COWARDLY as MUNIFICENT is to",
    options: ["GENEROUS", "STINGY", "CHARITABLE", "GIVING", "LIBERAL"],
    correct: 1,
    explanation: "INTREPID (fearless) is opposite to COWARDLY; MUNIFICENT (generous) is opposite to STINGY."
  },
  {
    id: 66,
    text: "PENINSULA : LAND :: LAGOON : ?",
    options: ["OCEAN", "WATER", "LAKE", "BAY", "SEA"],
    correct: 1,
    explanation: "A PENINSULA is surrounded by water but is LAND; a LAGOON is surrounded by land but is WATER."
  },
  {
    id: 67,
    text: "LOQUACIOUS is to TACITURN as PERTINENT is to",
    options: ["RELEVANT", "APPROPRIATE", "FITTING", "IRRELEVANT", "SUITABLE"],
    correct: 3,
    explanation: "LOQUACIOUS (talkative) is opposite to TACITURN; PERTINENT (relevant) is opposite to IRRELEVANT."
  },
  {
    id: 68,
    text: "PSEUDONYM : AUTHOR :: ALIAS : ?",
    options: ["NAME", "IDENTITY", "CRIMINAL", "PERSON", "FAKE"],
    correct: 2,
    explanation: "A PSEUDONYM is a false name used by an AUTHOR; an ALIAS is a false name used by a CRIMINAL."
  },
  {
    id: 69,
    text: "MAGNANIMOUS is to PETTY as METICULOUS is to",
    options: ["CAREFUL", "PRECISE", "DETAILED", "CARELESS", "THOROUGH"],
    correct: 3,
    explanation: "MAGNANIMOUS (generous) is opposite to PETTY; METICULOUS (careful) is opposite to CARELESS."
  },
  {
    id: 70,
    text: "FABLE : MORAL :: PARABLE : ?",
    options: ["STORY", "LESSON", "RELIGION", "TEACHING", "TRUTH"],
    correct: 1,
    explanation: "A FABLE teaches a MORAL; a PARABLE teaches a LESSON."
  },
  {
    id: 71,
    text: "DOGMATIC is to FLEXIBLE as SEDENTARY is to",
    options: ["STILL", "SITTING", "STATIONARY", "ACTIVE", "INACTIVE"],
    correct: 3,
    explanation: "DOGMATIC (rigid) is opposite to FLEXIBLE; SEDENTARY (inactive) is opposite to ACTIVE."
  },
  {
    id: 72,
    text: "ANVIL : FORGE :: LATHE : ?",
    options: ["WORKSHOP", "MACHINE", "METAL", "WOOD", "TURN"],
    correct: 0,
    explanation: "An ANVIL is used in a FORGE; a LATHE is used in a WORKSHOP."
  },
  {
    id: 73,
    text: "PERNICIOUS is to BENEFICIAL as SUPERFLUOUS is to",
    options: ["EXTRA", "UNNECESSARY", "EXCESS", "REDUNDANT", "ESSENTIAL"],
    correct: 4,
    explanation: "PERNICIOUS (harmful) is opposite to BENEFICIAL; SUPERFLUOUS (unnecessary) is opposite to ESSENTIAL."
  },
  {
    id: 74,
    text: "HERBIVORE : PLANTS :: CARNIVORE : ?",
    options: ["ANIMALS", "MEAT", "FOOD", "PREDATOR", "HUNTER"],
    correct: 1,
    explanation: "A HERBIVORE eats PLANTS; a CARNIVORE eats MEAT."
  },
  {
    id: 75,
    text: "ASTUTE is to OBTUSE as VIGILANT is to",
    options: ["WATCHFUL", "ALERT", "ATTENTIVE", "CARELESS", "OBSERVANT"],
    correct: 3,
    explanation: "ASTUTE (shrewd) is opposite to OBTUSE; VIGILANT (watchful) is opposite to CARELESS."
  },
  {
    id: 76,
    text: "EPITAPH : TOMBSTONE :: INSCRIPTION : ?",
    options: ["WRITING", "MONUMENT", "WORDS", "STONE", "MEMORIAL"],
    correct: 1,
    explanation: "An EPITAPH is text on a TOMBSTONE; an INSCRIPTION is text on a MONUMENT."
  },
  {
    id: 77,
    text: "VOLATILE is to STABLE as AMBIGUOUS is to",
    options: ["UNCLEAR", "VAGUE", "CONFUSING", "DEFINITE", "UNCERTAIN"],
    correct: 3,
    explanation: "VOLATILE (unstable) is opposite to STABLE; AMBIGUOUS (unclear) is opposite to DEFINITE."
  },
  {
    id: 78,
    text: "CURATOR : MUSEUM :: SOMMELIER : ?",
    options: ["BEER", "RESTAURANT", "FOOD", "DRINK", "CELLAR"],
    correct: 1,
    explanation: "A CURATOR manages a MUSEUM; a SOMMELIER manages wine at a RESTAURANT."
  },
  {
    id: 79,
    text: "EXORBITANT is to REASONABLE as MEAGER is to",
    options: ["SMALL", "LITTLE", "SPARSE", "SCANT", "ABUNDANT"],
    correct: 4,
    explanation: "EXORBITANT (excessive) is opposite to REASONABLE; MEAGER (insufficient) is opposite to ABUNDANT."
  },
  {
    id: 80,
    text: "CRESCENDO : VOLUME :: ACCELERANDO : ?",
    options: ["MUSIC", "CAR", "SOUND", "TEMPO", "RHYTHM"],
    correct: 3,
    explanation: "CRESCENDO indicates increasing VOLUME; ACCELERANDO indicates increasing TEMPO."
  },
  {
    id: 81,
    text: "APATHY is to ENTHUSIASM as DISCORD is to",
    options: ["CONFLICT", "DISAGREEMENT", "HARMONY", "DISPUTE", "STRIFE"],
    correct: 2,
    explanation: "APATHY (indifference) is opposite to ENTHUSIASM; DISCORD (conflict) is opposite to HARMONY."
  },
  {
    id: 82,
    text: "SYNOPSIS : PLOT :: ABSTRACT : ?",
    options: ["RESEARCH", "PAPER", "SUMMARY", "ARTICLE", "CONCLUSION"],
    correct: 2,
    explanation: "A SYNOPSIS summarizes a PLOT; an ABSTRACT summarizes RESEARCH."
  },
  {
    id: 83,
    text: "IMMUTABLE is to CHANGEABLE as TANGIBLE is to",
    options: ["TOUCHABLE", "SOLID", "PHYSICAL", "REAL", "EHTEREAL"],
    correct: 4,
    explanation: "IMMUTABLE (unchangeable) is opposite to CHANGEABLE; TANGIBLE (physical) is opposite to EHTEREAL."
  },
  {
    id: 84,
    text: "TROWEL : MASON :: CHISEL : ?",
    options: ["TOOL", "SCULPTOR", "STONE", "CARVE", "WOOD"],
    correct: 1,
    explanation: "A TROWEL is a tool used by a MASON; a CHISEL is a tool used by a SCULPTOR."
  },
  {
    id: 85,
    text: "OSTENTATIOUS is to MODEST as CLANDESTINE is to",
    options: ["SECRET", "HIDDEN", "OBVIOUS", "COVERT", "CONCEALED"],
    correct: 2,
    explanation: "OSTENTATIOUS (showy) is opposite to MODEST; CLANDESTINE (secret) is opposite to OPEN."
  },
  {
    id: 86,
    text: "STANZA : POEM :: MOVEMENT : ?",
    options: ["DANCE", "MELODY", "MUSIC", "ORCHESTRA", "SYMPHONY"],
    correct: 4,
    explanation: "A STANZA is a section of a POEM; a MOVEMENT is a section of a SYMPHONY."
  },
  {
    id: 87,
    text: "INEXORABLE is to PREVENTABLE as INDELIBLE is to",
    options: ["PERMANENT", "LASTING", "ERASABLE", "FIXED", "ENDURING"],
    correct: 2,
    explanation: "INEXORABLE (unstoppable) is opposite to PREVENTABLE; INDELIBLE (permanent) is opposite to ERASABLE."
  },
  {
    id: 88,
    text: "ARCHIPELAGO : ISLANDS :: GALAXY : ?",
    options: ["SPACE", "STARS", "UNIVERSE", "PLANETS", "COSMOS"],
    correct: 1,
    explanation: "An ARCHIPELAGO is a group of ISLANDS; a GALAXY is a group of STARS."
  },
  {
    id: 89,
    text: "INGENUOUS is to CUNNING as INNOCUOUS is to",
    options: ["HARMLESS", "SAFE", "DANGEROUS", "MILD", "BENIGN"],
    correct: 2,
    explanation: "INGENUOUS (naive) is opposite to CUNNING; INNOCUOUS (harmless) is opposite to DANGEROUS."
  },
  {
    id: 90,
    text: "LEXICON : VOCABULARY :: COMPENDIUM : ?",
    options: ["BOOK", "STUFF", "COLLECTION", "SUMMARY", "INFORMATION"],
    correct: 4,
    explanation: "A LEXICON contains VOCABULARY; a COMPENDIUM contains INFORMATION."
  },
  {
    id: 91,
    text: "DELETERIOUS is to BENEFICIAL as HEINOUS is to",
    options: ["TERRIBLE", "EVIL", "WICKED", "VIRTUOUS", "ATROCIOUS"],
    correct: 3,
    explanation: "DELETERIOUS (harmful) is opposite to BENEFICIAL; HEINOUS (evil) is opposite to VIRTUOUS."
  },
  {
    id: 92,
    text: "PROTAGONIST : STORY :: THESIS : ?",
    options: ["PAPER", "ARGUMENT", "THING", "ESSAY", "RESEARCH"],
    correct: 1,
    explanation: "The PROTAGONIST is central to a STORY; the THESIS is central to an ARGUMENT."
  },
  {
    id: 93,
    text: "ALTRUISTIC is to SELFISH as PRAGMATIC is to",
    options: ["PRACTICAL", "REALISTIC", "IMPRACTICAL", "SENSIBLE", "LOGICAL"],
    correct: 2,
    explanation: "ALTRUISTIC (selfless) is opposite to SELFISH; PRAGMATIC (practical) is opposite to IMPRACTICAL."
  },
  {
    id: 94,
    text: "SCYTHE : REAP :: SICKLE : ?",
    options: ["LOOP", "HARVEST", "FARM", "CROP", "TOOL"],
    correct: 1,
    explanation: "A SCYTHE is used to REAP; a SICKLE is used to HARVEST."
  },
  {
    id: 95,
    text: "LUCRATIVE is to UNPROFITABLE as OMINOUS is to",
    options: ["THREATENING", "DARK", "MENACINGLY", "FOREBODING", "AUSPICIOUS"],
    correct: 2,
    explanation: "LUCRATIVE (profitable) is opposite to UNPROFITABLE; OMINOUS (threatening) is opposite to AUSPICIOUS."
  },
  {
    id: 96,
    text: "CODA : MUSIC :: EPILOGUE : ?",
    options: ["BOOK", "END", "ATLAS", "CHAPTER", "CONCLUSION"],
    correct: 0,
    explanation: "A CODA is the concluding section of MUSIC; an EPILOGUE is the concluding section of a BOOK."
  },
  {
    id: 97,
    text: "VINDICTIVE is to FORGIVING as PLAINTIVE is to",
    options: ["MOURNFUL", "SAD", "CHEERFUL", "SORROWFUL", "MELANCHOLY"],
    correct: 2,
    explanation: "VINDICTIVE (vengeful) is opposite to FORGIVING; PLAINTIVE (mournful) is opposite to CHEERFUL."
  },
  {
    id: 98,
    text: "CARTILAGE : JOINT :: TENDON : ?",
    options: ["BONE", "MUSCLE", "LIGAMENT", "BODY", "TISSUE"],
    correct: 1,
    explanation: "CARTILAGE cushions a JOINT; a TENDON connects to MUSCLE."
  },
  {
    id: 99,
    text: "TERSE is to VERBOSE as PLIABLE is to",
    options: ["FLEXIBLE", "SOFT", "RIGID", "BENDABLE", "MALLEABLE"],
    correct: 2,
    explanation: "TERSE (brief) is opposite to VERBOSE; PLIABLE (flexible) is opposite to RIGID."
  },
  {
    id: 100,
    text: "INCISION : SURGEON :: WELD : ?",
    options: ["METAL", "WELDER", "HEAT", "JOINT", "TOOL"],
    correct: 1,
    explanation: "An INCISION is made by a SURGEON; a WELD is made by a WELDER."
  },

  // Questions 101-150
{
    id: 101,
    text: "EPHEMERAL is to ETERNAL as NOXIOUS is to",
    options: ["HARMFUL", "WHOLESOME", "POISONOUS", "TOXIC", "DANGEROUS"],
    correct: 1,
    explanation: "EPHEMERAL (temporary) is opposite to ETERNAL; NOXIOUS (harmful) is opposite to WHOLESOME."
  },
  {
    id: 102,
    text: "LOGARITHM : MATHEMATICS :: METAPHOR : ?",
    options: ["IMAGE", "LITERATURE", "CONCEPT", "POTTERY", "COMPRISE"],
    correct: 1,
    explanation: "A LOGARITHM is a concept in MATHEMATICS; a METAPHOR is a concept in LITERATURE."
  },
  {
    id: 103,
    text: "ACRIMONIOUS is to AMICABLE as FORTUITOUS is to",
    options: ["LUCKY", "PLANNED", "FORTUNATE", "ACCIDENTAL", "CHANCE"],
    correct: 1,
    explanation: "ACRIMONIOUS (bitter) is opposite to AMICABLE; FORTUITOUS (accidental) is opposite to PLANNED."
  },
  {
    id: 104,
    text: "PESTLE : MORTAR :: KEY : ?",
    options: ["LOCK", "LAVA", "OPEN", "METAL", "SECURITY"],
    correct: 0,
    explanation: "A PESTLE is used with a MORTAR; a KEY is used with a LOCK."
  },
  {
    id: 105,
    text: "GREGARIOUS is to SOLITARY as DILATORY is to",
    options: ["SLOW", "DELAYED", "LATE", "PROMPT", "TARDY"],
    correct: 3,
    explanation: "GREGARIOUS (social) is opposite to SOLITARY; DILATORY (delaying) is opposite to PROMPT."
  },
  {
    id: 106,
    text: "CHROMOSOME : GENE :: SENTENCE : ?",
    options: ["WORD", "GRAM", "CLAUSE", "PARACHUTE", "LAKE"],
    correct: 0,
    explanation: "A CHROMOSOME contains GENES; a SENTENCE contains WORDS."
  },
  {
    id: 107,
    text: "LETHARGIC is to ENERGETIC as REPLETE is to",
    options: ["FULL", "COMPLETE", "SATISFIED", "EMPTY", "ABUNDANT"],
    correct: 3,
    explanation: "LETHARGIC (sluggish) is opposite to ENERGETIC; REPLETE (full) is opposite to EMPTY."
  },
  {
    id: 108,
    text: "BUOY : NAVIGATION :: BEACON : ?",
    options: ["LIGHT", "WARNING", "SIGN", "SAFETY", "SHIP"],
    correct: 1,
    explanation: "A BUOY aids NAVIGATION; a BEACON provides WARNING."
  },
  {
    id: 109,
    text: "POMPOUS is to HUMBLE as RECALCITRANT is to",
    options: ["STUBBORN", "DEFIANT", "REBELLIOUS", "COMPLIANT", "RESISTANT"],
    correct: 3,
    explanation: "POMPOUS (arrogant) is opposite to HUMBLE; RECALCITRANT (defiant) is opposite to COMPLIANT."
  },
  {
    id: 110,
    text: "BALLAD : NARRATIVE :: LIMERICK : ?",
    options: ["HUMOR", "MOPE", "THYME", "VERSATILE", "SHORT"],
    correct: 0,
    explanation: "A BALLAD tells a NARRATIVE; a LIMERICK provides HUMOR."
  },
  {
    id: 111,
    text: "STRIDENT is to MELODIOUS as DISMAL is to",
    options: ["GLOOMY", "CHEERFUL", "DARK", "DREARY", "BLEAK"],
    correct: 1,
    explanation: "STRIDENT (harsh) is opposite to MELODIOUS; DISMAL (gloomy) is opposite to CHEERFUL."
  },
  {
    id: 112,
    text: "CENTRIFUGE : SEPARATION :: CATALYST : ?",
    options: ["CHEMISTRY", "REACTION", "SPRINT", "ACCELERATION", "CHANGE"],
    correct: 3,
    explanation: "A CENTRIFUGE causes SEPARATION; a CATALYST causes ACCELERATION of reactions."
  },
  {
    id: 113,
    text: "CAUSTIC is to SOOTHING as ABRASIVE is to",
    options: ["ROUGH", "SMOOTH", "HARSH", "COARSE", "GRATING"],
    correct: 1,
    explanation: "CAUSTIC (corrosive) is opposite to SOOTHING; ABRASIVE (rough) is opposite to SMOOTH."
  },
  {
    id: 114,
    text: "REFERENDUM : VOTE :: CENSUS : ?",
    options: ["COUNT", "POPULAR", "SURVEILLANCE", "GOVERN", "DATA"],
    correct: 0,
    explanation: "A REFERENDUM involves a VOTE; a CENSUS involves a COUNT."
  },
  {
    id: 115,
    text: "ENIGMATIC is to OBVIOUS as ARCHAIC is to",
    options: ["OLD", "ANCIENT", "OUTDATED", "MODERN", "OBSOLETE"],
    correct: 3,
    explanation: "ENIGMATIC (mysterious) is opposite to OBVIOUS; ARCHAIC (ancient) is opposite to MODERN."
  },
  {
    id: 116,
    text: "ELECTRODE : CURRENT :: CATALYST : ?",
    options: ["CHEMISTRY", "REACTION", "SPEED", "CHANGE", "PROCESS"],
    correct: 1,
    explanation: "An ELECTRODE conducts CURRENT; a CATALYST facilitates a REACTION."
  },
  {
    id: 117,
    text: "STOIC is to PASSIONATE as LUCID is to",
    options: ["CLEAR", "BRIGHT", "TRANSPARENT", "CONFUSED", "RATIONAL"],
    correct: 3,
    explanation: "STOIC (unemotional) is opposite to PASSIONATE; LUCID (clear-minded) is opposite to CONFUSED."
  },
  {
    id: 118,
    text: "BIOPSY : TISSUE :: AUTOPSY : ?",
    options: ["DEATH", "CADAVER", "CUT", "MEDICAL", "EXAMINATION"],
    correct: 1,
    explanation: "A BIOPSY examines TISSUE; an AUTOPSY examines a CADAVER."
  },
  {
    id: 119,
    text: "BELLICOSE is to PACIFIC as MOROSE is to",
    options: ["SAD", "GLOOMY", "SULLEN", "CHEERFUL", "MELANCHOLY"],
    correct: 3,
    explanation: "BELLICOSE (warlike) is opposite to PACIFIC; MOROSE (gloomy) is opposite to CHEERFUL."
  },
  {
    id: 120,
    text: "PRELUDE : INTRODUCTION :: DENOUEMENT : ?",
    options: ["FALLOFF", "RESOLUTION", "STORY", "CLIMAXING", "ILLUSION"],
    correct: 1,
    explanation: "A PRELUDE is an INTRODUCTION; a DENOUEMENT is a RESOLUTION of the plot."
  },
  {
    id: 121,
    text: "ADROIT is to CLUMSY as AUSTERE is to",
    options: ["SIMPLE", "PLAIN", "SEVERE", "ORNATE", "STARK"],
    correct: 3,
    explanation: "ADROIT (skillful) is opposite to CLUMSY; AUSTERE (simple) is opposite to ORNATE."
  },
  {
    id: 122,
    text: "CRUCIBLE : MELTING :: KILN : ?",
    options: ["FIRING", "HEARTH", "POTTERY", "CLAY", "CERAMIC"],
    correct: 0,
    explanation: "A CRUCIBLE is used for MELTING; a KILN is used for FIRING ceramics."
  },
  {
    id: 123,
    text: "PAUCITY is to ABUNDANCE as VILIFY is to",
    options: ["SLANDER", "CRITICIZE", "DEFAME", "PRAISE", "DENOUNCE"],
    correct: 3,
    explanation: "PAUCITY (scarcity) is opposite to ABUNDANCE; VILIFY (slander) is opposite to PRAISE."
  },
  {
    id: 124,
    text: "LIGAMENT : BONE :: SYNAPSE : ?",
    options: ["THOUGHT", "NEURON", "NERVOUS", "SIGNAL", "CONNECTION"],
    correct: 1,
    explanation: "A LIGAMENT connects BONE to bone; a SYNAPSE connects NEURON to neuron."
  },
  {
    id: 125,
    text: "ARDENT is to INDIFFERENT as BLATANT is to",
    options: ["OBVIOUS", "CLEAR", "CONSPICUOUS", "SUBTLE", "FLAGRANT"],
    correct: 3,
    explanation: "ARDENT (passionate) is opposite to INDIFFERENT; BLATANT (obvious) is opposite to SUBTLE."
  },
  {
    id: 126,
    text: "SONNET : FOURTEEN :: HAIKU : ?",
    options: ["JAPANESE", "SHORT", "THREE", "POETRY", "LINES"],
    correct: 2,
    explanation: "A SONNET has FOURTEEN lines; a HAIKU has THREE lines."
  },
  {
    id: 127,
    text: "COMPLACENT is to CONCERNED as CONTENTIOUS is to",
    options: ["ARGUMENTATIVE", "AGREEABLE", "HOSTILE", "QUARRELSOME", "BELLIGERENT"],
    correct: 1,
    explanation: "COMPLACENT (self-satisfied) is opposite to CONCERNED; CONTENTIOUS (argumentative) is opposite to AGREEABLE."
  },
  {
    id: 128,
    text: "ANVIL : BLACKSMITH :: EASEL : ?",
    options: ["PRINT", "CANVAS", "BRUSH", "ARTIST", "STUDIO"],
    correct: 3,
    explanation: "An ANVIL is used by a BLACKSMITH; an EASEL is used by an ARTIST."
  },
  {
    id: 129,
    text: "FURTIVE is to OPEN as INNOCUOUS is to",
    options: ["HARMLESS", "HARMFUL", "SAFE", "BENIGN", "MILD"],
    correct: 1,
    explanation: "FURTIVE (secretive) is opposite to OPEN; INNOCUOUS (harmless) is opposite to HARMFUL."
  },
  {
    id: 130,
    text: "COROLLARY : THEOREM :: POSTSCRIPT : ?",
    options: ["END", "ADDITION", "MESSAGE", "LETTER", "WRITTEN"],
    correct: 3,
    explanation: "A COROLLARY follows a THEOREM; a POSTSCRIPT follows a LETTER."
  },
  {
    id: 131,
    text: "PENSIVE is to THOUGHTLESS as STALWART is to",
    options: ["WEAK", "STRONG", "LOYAL", "STEADFAST", "FIRM"],
    correct: 0,
    explanation: "PENSIVE (thoughtful) is opposite to THOUGHTLESS; STALWART (strong) is opposite to WEAK."
  },
  {
    id: 132,
    text: "SCALPEL : INCISION :: NEEDLE : ?",
    options: ["THREAD", "WOUND", "SHARP", "SUTURE", "MEDICAL"],
    correct: 3,
    explanation: "A SCALPEL makes an INCISION; a NEEDLE makes a SUTURE."
  },
  {
    id: 133,
    text: "PROLIX is to CONCISE as WARY is to",
    options: ["CAUTIOUS", "RECKLESS", "CAREFUL", "VIGILANT", "ALERT"],
    correct: 1,
    explanation: "PROLIX (wordy) is opposite to CONCISE; WARY (cautious) is opposite to RECKLESS."
  },
  {
    id: 134,
    text: "METAPHOR : COMPARISON :: ALLITERATION : ?",
    options: ["POETRY", "SOUND", "WORDS", "REPETITION", "DEVICE"],
    correct: 3,
    explanation: "METAPHOR creates COMPARISON; ALLITERATION creates REPETITION of sounds."
  },
  {
    id: 135,
    text: "JOVIAL is to MOROSE as PLACID is to",
    options: ["CALM", "PEACEFUL", "TRANQUIL", "AGITATED", "SERENE"],
    correct: 3,
    explanation: "JOVIAL (cheerful) is opposite to MOROSE; PLACID (calm) is opposite to AGITATED."
  },
  {
    id: 136,
    text: "APIARY : BEES :: AVIARY : ?",
    options: ["ANIMALS", "BIRDS", "CAGE", "FLIGHT", "WINGS"],
    correct: 1,
    explanation: "An APIARY houses BEES; an AVIARY houses BIRDS."
  },
  {
    id: 137,
    text: "HACKNEYED is to ORIGINAL as MUNDANE is to",
    options: ["ORDINARY", "COMMON", "USUAL", "EXTRAORDINARY", "EVERYDAY"],
    correct: 3,
    explanation: "HACKNEYED (overused) is opposite to ORIGINAL; MUNDANE (ordinary) is opposite to EXTRAORDINARY."
  },
  {
    id: 138,
    text: "CONDUCTOR : BATON :: SURGEON : ?",
    options: ["HOSPITAL", "OPERATION", "SCALPEL", "PATIENT", "MEDICINE"],
    correct: 2,
    explanation: "A CONDUCTOR uses a BATON; a SURGEON uses a SCALPEL."
  },
  {
    id: 139,
    text: "OBTUSE is to ACUTE as ZENITH is to",
    options: ["PEAK", "NADIR", "TOP", "HEIGHT", "SUMMIT"],
    correct: 1,
    explanation: "OBTUSE (dull angle) is opposite to ACUTE; ZENITH (highest point) is opposite to NADIR."
  },
  {
    id: 140,
    text: "MONOLOGUE : ONE :: DIALOGUE : ?",
    options: ["CONVERSATION", "SPEECH", "TWO", "TALK", "DISCUSSION"],
    correct: 2,
    explanation: "A MONOLOGUE involves ONE speaker; a DIALOGUE involves TWO speakers."
  },
  {
    id: 141,
    text: "VEHEMENT is to MILD as REDUNDANT is to",
    options: ["REPETITIVE", "UNNECESSARY", "EXCESSIVE", "NECESSARY", "SUPERFLUOUS"],
    correct: 3,
    explanation: "VEHEMENT (intense) is opposite to MILD; REDUNDANT (unnecessary) is opposite to NECESSARY."
  },
  {
    id: 142,
    text: "TUNING FORK : PITCH :: LEVEL : ?",
    options: ["TOOL", "FLOAT", "HORIZONTAL", "SURFACE", "EVENT"],
    correct: 2,
    explanation: "A TUNING FORK establishes PITCH; a LEVEL establishes HORIZONTAL."
  },
  {
    id: 143,
    text: "MALIGNANT is to BENIGN as OVERT is to",
    options: ["OPEN", "COVERT", "OBVIOUS", "CLEAR", "APPARENT"],
    correct: 1,
    explanation: "MALIGNANT (harmful) is opposite to BENIGN; OVERT (open) is opposite to COVERT."
  },
  {
    id: 144,
    text: "ANTONYM : OPPOSITE :: SYNONYM : ?",
    options: ["WORD", "SYMANTIC", "SIMILAR", "LANGUAGE", "MEANING"],
    correct: 2,
    explanation: "An ANTONYM is an OPPOSITE; a SYNONYM is SIMILAR."
  },
  {
    id: 145,
    text: "IMPETUOUS is to DELIBERATE as CANDID is to",
    options: ["HONEST", "FRANK", "OPEN", "DECEITFUL", "SINCERE"],
    correct: 3,
    explanation: "IMPETUOUS (rash) is opposite to DELIBERATE; CANDID (honest) is opposite to DECEITFUL."
  },
  {
    id: 146,
    text: "THROTTLE : SPEED :: RUDDER : ?",
    options: ["BOAT", "STORM", "DIRECTION", "WATER", "NAVIGATION"],
    correct: 2,
    explanation: "A THROTTLE controls SPEED; a RUDDER controls DIRECTION."
  },
  {
    id: 147,
    text: "QUERULOUS is to CONTENT as DISPARATE is to",
    options: ["DIFFERENT", "UNLIKE", "SEPARATE", "SIMILAR", "DISTINCT"],
    correct: 3,
    explanation: "QUERULOUS (complaining) is opposite to CONTENT; DISPARATE (different) is opposite to SIMILAR."
  },
  {
    id: 148,
    text: "VIGNETTE : SCENE :: EXCERPT : ?",
    options: ["BOOKISH", "STORE", "WRITING", "PASSAGE", "TEXT"],
    correct: 3,
    explanation: "A VIGNETTE is a brief SCENE; an EXCERPT is a brief PASSAGE."
  },
  {
    id: 149,
    text: "STATIC is to DYNAMIC as LATENT is to",
    options: ["HIDDEN", "DORMANT", "POTENTIAL", "ACTIVE", "CONCEALED"],
    correct: 3,
    explanation: "STATIC (unchanging) is opposite to DYNAMIC; LATENT (dormant) is opposite to ACTIVE."
  },
  {
    id: 150,
    text: "ABACUS : CALCULATION :: PROTRACTOR : ?",
    options: ["MEASUREMENT", "ANGLE", "GEOMETRIC", "MATH", "TOOL"],
    correct: 1,
    explanation: "An ABACUS is used for CALCULATION; a PROTRACTOR is used for measuring ANGLE."
  },

  // Questions 151-200
  {
    id: 151,
    text: "CAPRICIOUS is to PREDICTABLE as COHERENT is to",
    options: ["LOGICAL", "CLEAR", "DISJOINTED", "CONNECTED", "ORGANIZED"],
    correct: 2,
    explanation: "CAPRICIOUS (unpredictable) is opposite to PREDICTABLE; COHERENT (logical) is opposite to DISJOINTED."
  },
  {
    id: 152,
    text: "PESTLE : GRIND :: SIEVE : ?",
    options: ["FILTER", "SPREAD", "STRAIGHTEN", "SPLIT", "SCREAM"],
    correct: 0,
    explanation: "A PESTLE is used to GRIND; a SIEVE is used to FILTER."
  },
  {
    id: 153,
    text: "OBSTINATE is to FLEXIBLE as FRUGAL is to",
    options: ["THRIFTY", "ECONOMICAL", "WASTEFUL", "CAREFUL", "SAVING"],
    correct: 2,
    explanation: "OBSTINATE (stubborn) is opposite to FLEXIBLE; FRUGAL (thrifty) is opposite to WASTEFUL."
  },
  {
    id: 154,
    text: "ALGORITHM : COMPUTER :: RECIPE : ?",
    options: ["FOOD", "COOKING", "CHEF", "KITCHEN", "INGREDIENTS"],
    correct: 1,
    explanation: "An ALGORITHM guides a COMPUTER; a RECIPE guides COOKING."
  },
  {
    id: 155,
    text: "DIMINUTIVE is to ENORMOUS as TEPID is to",
    options: ["WARM", "LUKEWARM", "MILD", "COOL", "SCALDING"],
    correct: 4,
    explanation: "DIMINUTIVE (tiny) is opposite to ENORMOUS; TEPID (lukewarm) is opposite to SCALDING."
  },
  {
    id: 156,
    text: "ELLIPSE : OVAL :: TRAPEZOID : ?",
    options: ["SQUARED", "QUADRILATERAL", "SHAPE", "RECTANGLES", "POLYGON"],
    correct: 1,
    explanation: "An ELLIPSE is a type of OVAL; a TRAPEZOID is a type of QUADRILATERAL."
  },
  {
    id: 157,
    text: "JUBILANT is to DESPONDENT as COPIOUS is to",
    options: ["ABUNDANT", "PLENTIFUL", "NUMEROUS", "AMPLE", "MEAGER"],
    correct: 4,
    explanation: "JUBILANT (joyful) is opposite to DESPONDENT; COPIOUS (abundant) is opposite to MEAGER."
  },
  {
    id: 158,
    text: "PALETTE : PAINTER :: LECTERN : ?",
    options: ["SPEAKER", "CHURCH", "STAND", "PODIUM", "BOOK"],
    correct: 0,
    explanation: "A PALETTE is used by a PAINTER; a LECTERN is used by a SPEAKER."
  },
  {
    id: 159,
    text: "ZENITH is to NADIR as APEX is to",
    options: ["TOP", "PEAK", "BASE", "HEIGHT", "SUMMIT"],
    correct: 2,
    explanation: "ZENITH (highest) is opposite to NADIR; APEX (top) is opposite to BASE."
  },
  {
    id: 160,
    text: "MANIFESTO : BELIEFS :: CONSTITUTION : ?",
    options: ["GOVERNMENT", "LAWS", "COUNTRY", "RIGHTS", "NATION"],
    correct: 1,
    explanation: "A MANIFESTO declares BELIEFS; a CONSTITUTION declares LAWS."
  },
  {
    id: 161,
    text: "EXPEDITE is to DELAY as CONSERVE is to",
    options: ["SAVE", "PROTECT", "WASTE", "PRESERVE", "KEEP"],
    correct: 2,
    explanation: "EXPEDITE (hasten) is opposite to DELAY; CONSERVE (save) is opposite to WASTE."
  },
  {
    id: 162,
    text: "PULLEY : LIFT :: LEVER : ?",
    options: ["MOVE", "PUSH", "TOOL", "PRY", "FORCE"],
    correct: 3,
    explanation: "A PULLEY is used to LIFT; a LEVER is used to PRY."
  },
  {
    id: 163,
    text: "SUCCINCT is to RAMBLING as INDIGENOUS is to",
    options: ["NATIVE", "LOCAL", "FOREIGN", "ABORIGINAL", "ENDEMIC"],
    correct: 2,
    explanation: "SUCCINCT (brief) is opposite to RAMBLING; INDIGENOUS (native) is opposite to FOREIGN."
  },
  {
    id: 164,
    text: "SOLSTICE : SEASON :: EQUINOX : ?",
    options: ["DAY", "EQUAL", "NIGHT", "BALANCING", "SPRING"],
    correct: 1,
    explanation: "SOLSTICE marks extreme SEASON; EQUINOX marks EQUAL day and night."
  },
  {
    id: 165,
    text: "DOCILE is to REBELLIOUS as OPAQUE is to",
    options: ["DARK", "CLOUDY", "TRANSPARENT", "THICK", "MURKY"],
    correct: 2,
    explanation: "DOCILE (compliant) is opposite to REBELLIOUS; OPAQUE (non-transparent) is opposite to TRANSPARENT."
  },
  {
    id: 166,
    text: "METRONOME : RHYTHM :: SEXTANT : ?",
    options: ["NAVIGABLE", "POSITION", "SHIP", "ANGLE", "OCEAN"],
    correct: 1,
    explanation: "A METRONOME maintains RHYTHM; a SEXTANT determines POSITION."
  },
  {
    id: 167,
    text: "EXACERBATE is to ALLEVIATE as BOLSTER is to",
    options: ["SUPPORT", "STRENGTHEN", "UNDERMINE", "REINFORCE", "FORTIFY"],
    correct: 2,
    explanation: "EXACERBATE (worsen) is opposite to ALLEVIATE; BOLSTER (support) is opposite to UNDERMINE."
  },
  {
    id: 168,
    text: "SYLLABLE : WORD :: ATOM : ?",
    options: ["MOLECULE", "ELEMENTAL", "PARTICLE", "MATTER", "CHEMISTRY"],
    correct: 0,
    explanation: "SYLLABLES combine to form WORDS; ATOMS combine to form MOLECULES."
  },
  {
    id: 169,
    text: "RETICENT is to GARRULOUS as URBANE is to",
    options: ["SOPHISTICATED", "REFINED", "CRUDE", "POLISHED", "CULTURED"],
    correct: 2,
    explanation: "RETICENT (reserved) is opposite to GARRULOUS; URBANE (refined) is opposite to CRUDE."
  },
  {
    id: 170,
    text: "CADENCE : MARCH :: TEMPO : ?",
    options: ["MUSIC", "SPEEDING", "BEATING", "RHYTHMIC", "SOUNDING"],
    correct: 0,
    explanation: "CADENCE is the rhythm of a MARCH; TEMPO is the speed of MUSIC."
  },
  {
    id: 171,
    text: "LUCID is to MURKY as CONCRETE is to",
    options: ["SOLID", "HARD", "ABSTRACT", "REAL", "TANGIBLE"],
    correct: 2,
    explanation: "LUCID (clear) is opposite to MURKY; CONCRETE (specific) is opposite to ABSTRACT."
  },
  {
    id: 172,
    text: "CHRONOMETER : TIME :: ODOMETER : ?",
    options: ["SPEED", "DISTANCE", "CAR", "TRAVEL", "MILES"],
    correct: 1,
    explanation: "A CHRONOMETER measures TIME; an ODOMETER measures DISTANCE."
  },
  {
    id: 173,
    text: "ORNATE is to AUSTERE as TRANSIENT is to",
    options: ["TEMPORARY", "BRIEF", "PERMANENT", "FLEETING", "SHORT"],
    correct: 2,
    explanation: "ORNATE (elaborate) is opposite to AUSTERE; TRANSIENT (temporary) is opposite to PERMANENT."
  },
  {
    id: 174,
    text: "EPILOGUE : BOOK :: CODA : ?",
    options: ["MUSIC", "BEND", "STRING", "SYMPHONY", "FINALLY"],
    correct: 0,
    explanation: "An EPILOGUE concludes a BOOK; a CODA concludes MUSIC."
  },
  {
    id: 175,
    text: "ZEALOUS is to APATHETIC as CURSORY is to",
    options: ["QUICK", "HASTY", "THOROUGH", "SUPERFICIAL", "BRIEF"],
    correct: 2,
    explanation: "ZEALOUS (enthusiastic) is opposite to APATHETIC; CURSORY (superficial) is opposite to THOROUGH."
  },
  {
    id: 176,
    text: "ANVIL : FORGE :: LOOM : ?",
    options: ["WEAVING", "FABRIC", "THREAD", "TEXTILE", "CLOTH"],
    correct: 0,
    explanation: "An ANVIL is used in a FORGE; a LOOM is used in WEAVING."
  },
  {
    id: 177,
    text: "PRISTINE is to SULLIED as ASTUTE is to",
    options: ["CLEVER", "SHARP", "FOOLISH", "INTELLIGENT", "WISE"],
    correct: 2,
    explanation: "PRISTINE (pure) is opposite to SULLIED; ASTUTE (shrewd) is opposite to FOOLISH."
  },
  {
    id: 178,
    text: "FUGUE : BACH :: SYMPHONY : ?",
    options: ["ORCHESTRA", "BEETHOVEN", "METALLICA", "CLASSICAL", "COMPOSER"],
    correct: 1,
    explanation: "FUGUE is associated with BACH; SYMPHONY is associated with BEETHOVEN."
  },
  {
    id: 179,
    text: "BENEVOLENT is to MALICIOUS as IMMACULATE is to",
    options: ["CLEAN", "PURE", "DEFILED", "SPOTLESS", "PRISTINE"],
    correct: 2,
    explanation: "BENEVOLENT (kind) is opposite to MALICIOUS; IMMACULATE (pure) is opposite to DEFILED."
  },
  {
    id: 180,
    text: "ABACUS : ARITHMETIC :: COMPASS : ?",
    options: ["DIRECTION", "GEOMETRY", "NAVIGATION", "CIRCLE", "DIRECTIONS"],
    correct: 1,
    explanation: "An ABACUS is used for ARITHMETIC; a COMPASS is used for GEOMETRY."
  },
  {
    id: 181,
    text: "INDIGENOUS is to EXOTIC as HOMOGENEOUS is to",
    options: ["SAME", "UNIFORM", "DIVERSE", "SIMILAR", "ALIKE"],
    correct: 2,
    explanation: "INDIGENOUS (native) is opposite to EXOTIC; HOMOGENEOUS (uniform) is opposite to DIVERSE."
  },
  {
    id: 182,
    text: "CADAVER : MORGUE :: SPECIMEN : ?",
    options: ["SCIENCE", "LABORATORY", "SAMPLE", "STUDY", "RESEARCH"],
    correct: 1,
    explanation: "A CADAVER is stored in a MORGUE; a SPECIMEN is stored in a LABORATORY."
  },
  {
    id: 183,
    text: "IMPECCABLE is to FLAWED as EPHEMERAL is to",
    options: ["TEMPORARY", "BRIEF", "LASTING", "FLEETING", "TRANSIENT"],
    correct: 2,
    explanation: "IMPECCABLE (perfect) is opposite to FLAWED; EPHEMERAL (temporary) is opposite to LASTING."
  },
  {
    id: 184,
    text: "AXIOM : PROOF :: HYPOTHESIS : ?",
    options: ["THEORY", "SCIENCE", "TABLE", "EXPERIMENT", "EXPLANATION"],
    correct: 3,
    explanation: "An AXIOM needs no PROOF; a HYPOTHESIS requires an EXPERIMENT."
  },
  {
    id: 185,
    text: "LOQUACIOUS is to RETICENT as ORNATE is to",
    options: ["DECORATIVE", "ELABORATE", "PLAIN", "FANCY", "DETAILED"],
    correct: 2,
    explanation: "LOQUACIOUS (talkative) is opposite to RETICENT; ORNATE (elaborate) is opposite to PLAIN."
  },
  {
    id: 186,
    text: "PHOTON : LIGHT :: ELECTRON : ?",
    options: ["ATOM", "ELECTRICITY", "CHARGE", "PARTICLE", "ENERGY"],
    correct: 1,
    explanation: "A PHOTON is the particle of LIGHT; an ELECTRON is the particle of ELECTRICITY."
  },
  {
    id: 187,
    text: "UBIQUITOUS is to SCARCE as TANGIBLE is to",
    options: ["REAL", "PHYSICAL", "EPHEMERAL", "SOLID", "CONCRETE"],
    correct: 2,
    explanation: "UBIQUITOUS (everywhere) is opposite to SCARCE; TANGIBLE (physical) is opposite to EPHEMERAL."
  },
  {
    id: 188,
    text: "CRUCIBLE : METALLURGY :: RETORT : ?",
    options: ["CHEMISTRY", "LABORATORY", "SCIENCE", "EXPERIMENT", "DISTILLATION"],
    correct: 4,
    explanation: "A CRUCIBLE is used in METALLURGY; a RETORT is used in DISTILLATION."
  },
  {
    id: 189,
    text: "SCRUPULOUS is to CARELESS as INDOLENT is to",
    options: ["LAZY", "SLUGGISH", "ENERGETIC", "IDLE", "LETHARGIC"],
    correct: 2,
    explanation: "SCRUPULOUS (careful) is opposite to CARELESS; INDOLENT (lazy) is opposite to ENERGETIC."
  },
  {
    id: 190,
    text: "PARADIGM : MODEL :: ALGORITHM : ?",
    options: ["COMPUTER", "PROCESS", "MATHEMATICS", "FORMULA", "CALCULATION"],
    correct: 1,
    explanation: "A PARADIGM is a MODEL; an ALGORITHM is a PROCESS."
  },
  {
    id: 191,
    text: "PROFUSE is to SPARSE as MUNDANE is to",
    options: ["ORDINARY", "COMMON", "EXCEPTIONAL", "EVERYDAY", "ROUTINE"],
    correct: 2,
    explanation: "PROFUSE (abundant) is opposite to SPARSE; MUNDANE (ordinary) is opposite to EXCEPTIONAL."
  },
  {
    id: 192,
    text: "FULCRUM : LEVER :: AXLE : ?",
    options: ["WHEEL", "CAR", "ROTATION", "SPIN", "TURN"],
    correct: 0,
    explanation: "A FULCRUM is the pivot point of a LEVER; an AXLE is the pivot point of a WHEEL."
  },
  {
    id: 193,
    text: "REPREHENSIBLE is to COMMENDABLE as PERNICIOUS is to",
    options: ["HARMFUL", "DESTRUCTIVE", "BENEFICIAL", "DANGEROUS", "TOXIC"],
    correct: 2,
    explanation: "REPREHENSIBLE (blameworthy) is opposite to COMMENDABLE; PERNICIOUS (harmful) is opposite to BENEFICIAL."
  },
  {
    id: 194,
    text: "METAPHOR : FIGURATIVE :: STATEMENT : ?",
    options: ["LITERAL", "SENTENCE", "WORDS", "SPEECH", "DECLARATION"],
    correct: 0,
    explanation: "A METAPHOR is FIGURATIVE language; a STATEMENT is LITERAL language."
  },
  {
    id: 195,
    text: "IMPETUOUS is to CAUTIOUS as BANAL is to",
    options: ["BORING", "COMMON", "ORIGINAL", "TRITE", "ORDINARY"],
    correct: 2,
    explanation: "IMPETUOUS (rash) is opposite to CAUTIOUS; BANAL (commonplace) is opposite to ORIGINAL."
  },
  {
    id: 196,
    text: "CHISEL : SCULPTOR :: TROWEL : ?",
    options: ["TOOL", "MASON", "CEMENT", "BRICK", "CONSTRUCTION"],
    correct: 1,
    explanation: "A CHISEL is the tool of a SCULPTOR; a TROWEL is the tool of a MASON."
  },
  {
    id: 197,
    text: "CONGENIAL is to HOSTILE as CURSORY is to",
    options: ["QUICK", "BRIEF", "DETAILED", "SUPERFICIAL", "HASTY"],
    correct: 2,
    explanation: "CONGENIAL (friendly) is opposite to HOSTILE; CURSORY (superficial) is opposite to DETAILED."
  },
  {
    id: 198,
    text: "SONNET : PETRARCH :: NOVEL : ?",
    options: ["FICTION", "CERVANTES", "BOOK", "STORY", "LITERATURE"],
    correct: 1,
    explanation: "The SONNET form is associated with PETRARCH; the NOVEL form is associated with CERVANTES."
  },
  {
    id: 199,
    text: "VORACIOUS is to SATISFIED as DIMINUTIVE is to",
    options: ["SMALL", "TINY", "MASSIVE", "LITTLE", "MINUTE"],
    correct: 2,
    explanation: "VORACIOUS (insatiable) is opposite to SATISFIED; DIMINUTIVE (tiny) is opposite to MASSIVE."
  },
  {
    id: 200,
    text: "HYPOTHESIS : THEORY :: CONCEPT : ?",
    options: ["IDEA", "PRINCIPLE", "THOUGHT", "NOTION", "UNDERSTANDING"],
    correct: 1,
    explanation: "A HYPOTHESIS develops into a THEORY; a CONCEPT develops into a PRINCIPLE."
  }
];

export const VERBAL_ANALOGIES_CONFIG = {
  sectionName: "Verbal Analogies",
  totalQuestions: 200,
  instructions: "Each question presents a relationship between two words. Select the word that best completes the analogy with the same relationship.",
  timeLimit: 8 * 60, // 8 minutes for 25 questions on actual test
  formats: [
    "WORD1 is to WORD2 as WORD3 is to ___",
    "WORD1 : WORD2 :: WORD3 : ?"
  ]
};
